import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_elevate-business-3/artifacts/2egq0yeb_Untitled%20design%20%281%29.png';

const SIZES = {
  sm: 'h-32',   // Header
  md: 'h-40',   // Footer
  lg: 'h-56',   // Hero / large display
};

export const Logo = ({ className = '', size = 'sm' }) => {
  const dim = SIZES[size] || SIZES.sm;
  return (
    <a href="#hero" data-testid="brand-logo" className={`inline-flex items-center select-none group ${className}`}>
      <img
        src={LOGO_URL}
        alt="ELEVA Digital"
        className={`${dim} w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]`}
        style={{
          mixBlendMode: 'screen',
          filter: 'drop-shadow(0 0 20px rgba(80, 150, 255, 0.35))',
        }}
      />
    </a>
  );
};
